// Generat automat din README.md
import React from 'react';

const Table = ({ columns, data, className = '' }) => {
  return (
    <div className={`overflow-hidden animate-in ${className}`}>
      <div className="overflow-x-auto custom-scrollbar">
        <table className="table-modern">
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th key={index} className="hidden sm:table-cell first:table-cell">
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((column, colIndex) => (
                  <td key={colIndex} className="hidden sm:table-cell first:table-cell">
                    <div className="truncate max-w-xs">
                      {column.render ? column.render(row[column.key], row) : row[column.key]}
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {/* Mobile card view for smaller screens */}
      <div className="sm:hidden space-y-3 mt-4">
        {data.map((row, index) => (
          <div key={index} className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 space-y-2">
            {columns.slice(0, 3).map((column, colIndex) => (
              <div key={colIndex} className="flex justify-between items-center">
                <span className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                  {column.header}
                </span>
                <div className="text-sm font-medium text-gray-900 dark:text-white truncate max-w-32">
                  {column.render ? column.render(row[column.key], row) : row[column.key]}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
      
      {data.length === 0 && (
        <div className="text-center py-8 sm:py-12">
          <div className="text-gray-400 dark:text-gray-500 text-base sm:text-lg mb-2">
            Nu există date pentru afișare
          </div>
          <div className="text-gray-500 dark:text-gray-600 text-xs sm:text-sm">
            Datele vor apărea aici când vor fi disponibile
          </div>
        </div>
      )}
    </div>
  );
};

export default Table;
